import styled from "styled-components";
import AntSteps from "antd/es/steps";

const Steps = styled(AntSteps)`
  .ant-steps-item-wait .ant-steps-item-icon {
    border-color: ${(p) => p.theme.colors.disabledText} !important;
  }
  .ant-steps-item-finish .ant-steps-item-icon {
    border-color: ${(p) => p.theme.colors.primaryBlue} !important;
  }
`;

export default Steps;
